<button
  class="start-over-button__button"
  target="_blank"
  rel="noopener noreferrer"
  tgButton2
  (click)="isStartOverModalVisible = true">
  Start Over
</button>
<tm-start-over
  *ngIf="isStartOverModalVisible"
  [categoryId]="categoryId"
  [subCategory]="subCategory"
  (closeModal)="onStartOverClose()">
</tm-start-over>
